/**
 * @generated SignedSource<<b380abbad433728e3819ee198c278ffe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLLlmConversationSource = "AGENT_EVAL_REGRESSION_JUDGE" | "ALERT_REMEDIATION" | "ALERT_RUNBOOK_HOOK" | "API" | "EVAL" | "INCIDENT" | "INTERNAL_AGENT" | "JOB" | "JOB_AGENT_DASHBOARD_SECTION" | "LINEAR" | "MCP_CLIENT" | "OPTIMIZER_CONFIGURATION" | "OPTIMIZER_ISSUE_REVISION" | "OPTIMIZER_PROPOSAL" | "OPTIMIZER_RUN" | "PR_IMPLEMENTATION" | "SLACK" | "STUDIO" | "SYSTEM" | "UI" | "WORKFLOW_MEMORY" | "WORKFLOW_MEMORY_CONSOLIDATE" | "WORKFLOW_MEMORY_EVAL" | "WORKFLOW_MEMORY_SHADOW_DIGEST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LlmConversationSidebar_me$data = {
  readonly llmConversations: ReadonlyArray<{
    readonly createdAt: any;
    readonly hasActiveInteraction: boolean;
    readonly hasUnreadResponse: boolean;
    readonly id: any;
    readonly lastUserMessageTime: string | null | undefined;
    readonly source: GraphQLLlmConversationSource | null | undefined;
    readonly sourceId: string | null | undefined;
    readonly title: string;
  }>;
  readonly " $fragmentType": "LlmConversationSidebar_me";
};
export type LlmConversationSidebar_me$key = {
  readonly " $data"?: LlmConversationSidebar_me$data;
  readonly " $fragmentSpreads": FragmentRefs<"LlmConversationSidebar_me">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LlmConversationSidebar_me",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "sources",
          "value": [
            "UI"
          ]
        }
      ],
      "concreteType": "GraphQLLlmConversation",
      "kind": "LinkedField",
      "name": "llmConversations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasActiveInteraction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUnreadResponse",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUserMessageTime",
          "storageKey": null
        }
      ],
      "storageKey": "llmConversations(sources:[\"UI\"])"
    }
  ],
  "type": "GraphQLUser",
  "abstractKey": null
};

(node as any).hash = "7de8e3496d28b678679b0c012afd9e7a";

export default node;
